// extracted by mini-css-extract-plugin
module.exports = {"browser":"ViewerWithSelectionCursor_browser__Vm0G4","innerBrowser":"ViewerWithSelectionCursor_innerBrowser__O31bd"};